import { isNil } from 'ramda';

import { SelectOption } from './Select';

export const mapSelectOptions = (values?: string[]): SelectOption[] =>
  (values || []).filter(v => !isNil(v)).map(value => ({ label: value, value }));
